import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExpandSimple"><Path d="M5.5 12.5V18.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 5.5H18.5V11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconExpandSimple;
